var _rect, _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 16,
    fill: "#FFF8EF",
    stroke: "#976821"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14.416C4.47094 15.0587 5.5729 16.3887 5.89998 18H18.1C18.4271 16.3887 19.5291 15.0587 21 14.416V8.58396C19.8466 8.08 18.92 7.15344 18.416 6L5.58396 6C5.08 7.15344 4.15344 8.08 3 8.58396L3 14.416Z",
    fill: "#FFF8EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.416H2.5V14.7432L2.79981 14.8742L3 14.416ZM5.89998 18L5.40998 18.0995L5.49128 18.5H5.89998V18ZM18.1 18V18.5H18.5087L18.59 18.0995L18.1 18ZM21 14.416L21.2002 14.8742L21.5 14.7432V14.416H21ZM21 8.58396L21.5 8.58396V8.25677L21.2002 8.12578L21 8.58396ZM18.416 6L18.8742 5.79981L18.7432 5.5H18.416V6ZM5.58396 6V5.5H5.25677L5.12578 5.79981L5.58396 6ZM3 8.58396L2.79981 8.12578L2.5 8.25677V8.58396H3ZM2.79981 14.8742C4.12418 15.4529 5.11588 16.6506 5.40998 18.0995L6.38999 17.9005C6.02992 16.1267 4.81771 14.6646 3.20019 13.9579L2.79981 14.8742ZM18.1 17.5H5.89998V18.5H18.1V17.5ZM20.7998 13.9579C19.1823 14.6646 17.9701 16.1267 17.61 17.9005L18.59 18.0995C18.8841 16.6506 19.8758 15.4529 21.2002 14.8742L20.7998 13.9579ZM20.5 8.58396V14.416H21.5V8.58396L20.5 8.58396ZM17.9579 6.20019C18.5123 7.46905 19.5309 8.48774 20.7998 9.04213L21.2002 8.12578C20.1622 7.67225 19.3278 6.83783 18.8742 5.79981L17.9579 6.20019ZM5.58396 6.5L18.416 6.5V5.5L5.58396 5.5V6.5ZM3.20019 9.04213C4.46905 8.48774 5.48774 7.46905 6.04213 6.20019L5.12578 5.79981C4.67225 6.83783 3.83783 7.67225 2.79981 8.12578L3.20019 9.04213ZM3.5 14.416L3.5 8.58396H2.5L2.5 14.416H3.5Z",
    fill: "#976821"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 1.5,
    fill: "white",
    stroke: "#976821"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 1.5,
    fill: "white",
    stroke: "#976821"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L9 15",
    stroke: "#976821",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPercentage);
export default __webpack_public_path__ + "static/media/money--percentage.e4c8ee85.svg";
export { ForwardRef as ReactComponent };